export const leadingZero = (num: number): string => `0${num}`.slice(-2);
